import React from 'react';
import { protectedRoute } from '@/modules/core/root/protected/route';
import { AuthorizationError, RouteErrorHandler } from '@/shared/components/route-error-handler';
import { createRoute, Outlet } from '@tanstack/react-router';

export const remoteManagementRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'remote-management',
  component: Outlet,
  beforeLoad: ({ context }) => {
    if (!context.auth.userIsAdmin()) {
      throw new AuthorizationError('User is not an admin');
    }
  },
  errorComponent: ({ error, reset }) => {
    return <RouteErrorHandler error={error} reset={reset} routeName="remote-management" />;
  },
});
